export default __webpack_public_path__ + "static/grouped-bar-4c99c31b746b548b07e4939e2240e764.png";